/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_CariconInputs */

const en_enum_custom_page_icon_caricon = /** @type {(inputs: Enum_Custom_Page_Icon_CariconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Car`)
};

const de_enum_custom_page_icon_caricon = /** @type {(inputs: Enum_Custom_Page_Icon_CariconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Car" |
*
* @param {Enum_Custom_Page_Icon_CariconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_caricon = /** @type {((inputs?: Enum_Custom_Page_Icon_CariconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_CariconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_caricon(inputs)
	return de_enum_custom_page_icon_caricon(inputs)
});